<body class="gray-bg">
  <div class="middle-box text-center animated fadeInDown">
    <h1>500</h1>
    <h3 class="font-bold">Internal Server Error</h3>
    <div class="error-desc m-b">
      The server encountered something unexpected that did not allow it to complete the request. We apologize.
      <br />
      You can go back to main page:
      <br />
    </div>
    <shared-ui-buttons-button [type]="buttonType.Primary" [text]="'Home'" (action)="navigateBack()"></shared-ui-buttons-button>
  </div>
</body>
